import PropTypes from 'prop-types';
import React from 'react';

const PerPageOptionComponent = function ({ selectedOption, perPageOptions, onChangeNumPerPage }) {
  return (
    <div className="paginator-perpage-option">
      Display
      {perPageOptions.map((option) => {
        return option === selectedOption ? (
          <span key={option} className="current">
            {option}
          </span>
        ) : (
          <span key={option} className="active" onClick={() => onChangeNumPerPage(option)}>
            {option}
          </span>
        );
      })}
    </div>
  );
};

PerPageOptionComponent.propTypes = {
  selectedOption: PropTypes.number.isRequired,
  perPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeNumPerPage: PropTypes.func.isRequired,
};

export default PerPageOptionComponent;
